import { observer } from 'mobx-react';
import ExperienceSelectionView from '../ExperienceSelectionView';

function RegistrationEnrollment() {
  return <ExperienceSelectionView />;
}

export default observer(RegistrationEnrollment);
